import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import Row from './Row'
import Loader from '@app/components/ui/placeholders/Loader'
import { sortedClasses } from '@app/helpers/classesHelper'
import _ from 'lodash'

import { Can } from '@app/context/ability-context'
import SVG from 'react-inlinesvg'
import plus from '@icons/add/user-primary'

const Table = ({ classes }) => {
  const { fetching } = classes
  if (fetching) { return <Loader /> }

  return (
    <div className="grid grid--sm-1 grid--md-2 grid--xl-3">
      <Can I="create" a="Class">
        <Link to="/teachers/classes/new" className="link link--icon-left link--text-black grid__item grid__item--interactable f--upper">
          <SVG src={plus} />
          { I18n.t('shared.teacher.add_class.add_group') }
        </Link>
      </Can>
      {
        _.map(sortedClasses(classes.objects), (group) => {
          return <Row
            key={group.object.id}
            group={group}
            href={`/teachers/classes/${group.object.id}/learners`}
          />
        })
      }
    </div>
  )
}

Table.propTypes = {
  classes: PropTypes.object.isRequired
}

export default Table
